<h6 class="loginHeadingText text-start mt-39">
    <div class="d-flex">
        <div class="me-2">
            <input type="radio" name="radiolist" [checked]="isRadioChecked" (change)="handleRadioChange($event)" />
        </div>
        <div>
            <p class="text-blue">SELECT EACH PRODUCT</p>
        </div>
    </div>
</h6>



<div class="d-flex justify-content-between w-100 mb-2" [ngClass]="{'disabled-row': disableProductsSection}">
    <div class="row col-md-12">
        <div class="col-md-7 align-self-center">
            <h6 class="searchByText">SEARCH BY PRODUCT DESCRIPTION, UPC OR ITEM#</h6>

        </div>
        <!-- <div class="col-md-3" style="text-align:right">
                                 
                        </div>-->
        <div class="col-md-5" style="text-align:right">
            <div class="d-flex justify-content-end">
                <select  class="form-select me-2 w-50"
                [(ngModel)]="newProductCategoryID" (ngModelChange)="changeCategory()" aria-label="Default select example"
                [disabled]="disableProductsSection">
                <option [ngValue]="null">Select Category</option>
                <option *ngFor="let item of refinecategoryList" [ngValue]="item.value">
                    {{item.label}}
                </option>
            </select>
                <button class="btn progressBtn w-50 me-2 ps-2" role="button" (click)="addNewProduct()" [disabled]="enableAddProduct">
                    ADD NEW PRODUCT
                </button>
                <!-- [ngClass]="{'red-border': newProductCategoryID | checkIsValueEmptyPipe}" -->
               

            </div>

        </div>
    </div>
    <div>
        <img src="assets/images/export.png" class="w-30" style="cursor: pointer; margin-left: -6px; width: 36px; height: 39px; margin-top: -3px;"
            *ngIf="isProductListManualChecked" alt="" title="Export to Excel" (click)="exportProductsExcelData()">
        <!-- <img src="assets/images/office365.png" class="me-1 w-25px pointerCursor" 
                alt="" title="Export to Excel"> -->
    </div>
</div>


<table class="table datatable border-x-0 mb-0">
    <tbody>
        <tr class="subheaderrr">
            <th width="1%"></th>
            <th width="5%"> TYPE</th>
            <th width="25%"> PRODUCT DESCRIPTION </th>
            <th width="8%"> ITEM# </th>
            <th width="8%">UPC</th>
            <th width="1%" class="border-end-0"></th>
        </tr>

        <ng-container *ngFor="let row of selectedProductRows; let i = index">

            <tr *ngIf="row.isItRemove==false">
                <td [ngClass]="parentColAutoComplete">
                    <ng-container *ngIf="!row.isManuallyAddedNewProduct; else addnewproductitem">
                        <img src="assets/images/plus_icon.svg" alt="" (click)="addProductItem(i)">
                    </ng-container>
                    <ng-template #addnewproductitem>
                        <img src="assets/images/plus_icon.svg" alt="" (click)="addProductItem(i)">
                    </ng-template>
                </td>
                <td>
                    <div class="toggle-container">
                        <div class="parent" [class.selected]="row.isParentSelected" (click)="toggleSelection('parent',i)">
                          <span class="parent-text" [class.selected]="row.isParentSelected">Parent</span>
                        </div>
                        <div class="separator"></div>
                        <div class="child" [class.selected]="!row.isParentSelected" (click)="toggleSelection('child',i)">
                          <span class="child-text" [class.selected]="!row.isParentSelected">Child</span>
                        </div>
                      </div>
                      
                </td>
                <td [ngClass]="parentColAutoComplete">
                    <ng-container *ngIf="!row.isManuallyAddedNewProduct; else newProductTemplate">
                        <p-autoComplete [(ngModel)]="row.product" (ngModelChange)="onAnyFieldValueChange($event)" [suggestions]="filteredProducts" (completeMethod)="filterProducts($event)" (onSelect)="onSelect($event, row)"
                            field="productTitle" [disabled]="disableProductsSection" placeholder="SEARCH BY PRODUCT DESCRIPTION, UPC OR ITEM#"
                            [emptyMessage]="'No products found. Please use the ADD NEW PRODUCT button to add new product'">
                            <ng-template let-product pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    <div>{{ product.productTitle }}</div>
                                    <!-- Show product title here -->
                                </div>
                            </ng-template>
                        </p-autoComplete>
                        <img src="assets/images/magnifying-glass.png" alt="" class="glassIcon">
                    </ng-container>
                    <ng-template #newProductTemplate>
                        <div class="row">
                            <div [ngClass]="{'col-md-7': !row.isParentSelected && row.productID === 0, 'col-md-14': row.isParentSelected || row.productID !== 0}">
                                <!-- [ngClass]="{'red-border': row.newProductTitle | checkIsValueEmptyPipe}" -->
                                <input type="text" class="form-control newproductname" [disabled]="disableProductsSection" [(ngModel)]="row.newProductTitle" (ngModelChange)="onAnyFieldValueChange($event)"
                                    placeholder="Type a new product description" />
                            </div>
                            <div class="col-md-5" *ngIf="!row.isParentSelected && row.productID==0">
                                <p-autoComplete [(ngModel)]="row.newProductParentTitle" id="parentProductsearch" [suggestions]="filteredProductsForCustom"
                                    (completeMethod)="filterProductsForCustomItems($event)" (ngModelChange)="onAnyFieldValueChange($event)" (onSelect)="onSelectNewProductForChild($event, row, row.newProductID)"
                                    field="productTitle" [disabled]="disableProductsSection" placeholder="Type or search parent product"
                                    [emptyMessage]="'Parent does not exist. Please add it first'">
                                    <ng-template let-product pTemplate="item">
                                        <div class="flex align-items-center gap-2">
                                            <div>{{ product.productTitle }}</div>
                                        </div>
                                    </ng-template>
                                </p-autoComplete>
                                <img src="assets/images/magnifying-glass.png" alt="" class="glassIcon">
                            </div>

                        </div>
                    </ng-template>
                </td>
                <td [ngClass]="parentCol">
                    <!--[ngClass]="{'red-border': row.vendorItemNumber | checkIsValueEmptyPipe}"-->
                    <input *ngIf="row.isManuallyAddedNewProduct; else vendorItemNumber" (ngModelChange)="onAnyFieldValueChange($event)" class="form-control" type="text" [(ngModel)]="row.vendorItemNumber"
                        placeholder="Type item#" (input)="onVendorItemNumberInput(row)" [disabled]="disableProductsSection">
                    <ng-template #vendorItemNumber>
                        <strong>{{row.vendorItemNumber}}</strong>
                    </ng-template>
                </td>
                <td [ngClass]="parentCol">
                    <!-- [ngClass]="{'red-border': row.upc | checkIsValueEmptyPipe}" -->
                    <input *ngIf="row.isManuallyAddedNewProduct; else upcField" (ngModelChange)="onAnyFieldValueChange($event)" class="form-control" type="text" [(ngModel)]="row.upc" placeholder="Type UPC"
                        (input)="onUPCInput(row)" [disabled]="disableProductsSection">
                    <ng-template #upcField>
                        <strong>{{row.upc}}</strong>
                    </ng-template>
                </td>
                <td [ngClass]="parentCol">
                    <ng-container *ngIf="!row.isManuallyAddedNewProduct; else newproductremoveicon">
                        <img *ngIf="isShowRemoveProductIcon" src="assets/images/close_mark.svg" alt="" (click)="removeMaster(i)">
                    </ng-container>
                    <ng-template #newproductremoveicon>
                        <img src="assets/images/close_mark.svg" alt="" (click)="removeCustomProduct(row,i)">
                    </ng-template>

                </td>
            </tr>

            <!-- Child Rows -->

            <tr *ngFor="let child of row.subProducts; let j = index">
               
                <td [ngClass]="childColAutoComplete">
                    <!-- {{row.prIndex}} / {{row.crIndex}} -->
                </td>
                <td>
                    <!-- <div class="toggle-container">
                        <div class="parent" [class.selected]="row.isParentSelected" (click)="toggleSelection('parent',i)">
                          <span class="parent-text" [class.selected]="row.isParentSelected">Parent</span>
                        </div>
                        <div class="separator"></div>
                        <div class="child" [class.selected]="!row.isParentSelected" (click)="toggleSelection('child',i)">
                          <span class="child-text" [class.selected]="!row.isParentSelected">Child</span>
                        </div>
                      </div> -->
                      <div class="childsel">
                        <span class="child-text">Child</span>
                      </div>
                      
                </td>
                <td [ngClass]="childColAutoComplete">
                    {{ child.product }}
                </td>
                <td [ngClass]="childCol">
                    <strong>{{ child.vendorItemNumber }}</strong>
                    <!-- <input type="text" [(ngModel)]="row.VendorItemNumber" placeholder="VendorItemNumber" disabled /> -->
                </td>
                <td [ngClass]="childCol">
                    <strong>{{ child.upc}}</strong>
                </td>
                <td [ngClass]="childCol">
                    <img src="assets/images/close_mark.svg" alt="" (click)="removeChild(i, j)">
                </td>
            </tr>

        </ng-container>


    </tbody>
</table>
<br/>